// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
/**
 * Lazy loader for premium plan dev view renderer
 */ export const premiumPlanRenderLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-premiumplan-render" */ "./premiumPlanViewRender")).then((bundle)=>{
        return bundle.premiumPlanViewRenderer;
    });
export const premiumPlanInstantiateLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-premiumplan-instantiate" */ "./premiumPlanViewInstantiate"));
export const LazyPremiumPlanView = /*#__PURE__*/ lazy(()=>premiumPlanRenderLoader().then((mod)=>{
        return {
            default: ()=>mod.render({
                    modalLayerHostId: "modalLayerHostId"
                })
        };
    }));
